import type { ButtonConfig } from '../declare'
import * as Header from './header'
import { $consts } from 'src/plugins'

/**
 * 编辑表单子表表头配置按钮
 * @param props 
 * @returns 
 */
const HeaderButton = (props: { config: ButtonConfig }) => {
  const { BTN_TYPE } = props.config
  switch (BTN_TYPE) {
    // 新增按钮
    case $consts['TABLE/BTN_TYPE_ADD']:
      return <Header.AddBtn config={props.config} />
    // 批量新增按钮
    case $consts['TABLE/BTN_TYPE_BATCH_ADD']:
      return <Header.BatchAddBtn config={props.config} />
    // 自定义渲染按钮
    case $consts['TABLE/BTN_TYPE_CUSTOM_BTN']:
      return <Header.CustomRenderBtn config={props.config} />
    // 删除按钮
    case $consts['TABLE/BTN_TYPE_DELETE']:
      return <Header.DeleteConfirmBtn config={props.config} />
    default:
      return <div />
  }
}

export default HeaderButton
